import { useFeatureFlag } from './useFeatureFlag';
import { FeatureFlagKeys } from '../constants/ff.posthog';

/**
 * Whether the office profile's Location Admins tab (GOTU-7483) is on for this
 * admin, released with the GOTU-7482 Location Users surfaces.
 *
 * Two surfaces read this and must agree, so they share one hook rather than
 * two `useFeatureFlag` calls: `DNTTabs`, which offers the tab, and
 * `LocationAdminsTabScreen`, which renders it on a deep link.
 *
 * **Reactive, not the synchronous `getShouldEnableLocationUsers()` in
 * `src/posthog.js`.** PostHog answers `false` until its flags arrive, so a
 * one-shot read would hide the tab from a flag-on admin who reached the
 * profile first. The synchronous reader is for `App.js` route registration.
 *
 * Callers must branch **above** the data hooks: `useLocationAdmins` is a React
 * Query hook and cannot be called conditionally, so a gate placed after it
 * would still send the organization-service request this flag holds back.
 */
export const useLocationUsersAdminPanel = () =>
  useFeatureFlag(FeatureFlagKeys.locationUsersAdminPanel, false);

export default useLocationUsersAdminPanel;
